// extracted by mini-css-extract-plugin
export default {"button":"ArrowButton_button__NOHng","line":"ArrowButton_line__TDYpO","svg":"ArrowButton_svg__okDla"};